<kpd-hotkey keys="up" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="left" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="down" (action)="onNext()"></kpd-hotkey>
<kpd-hotkey keys="right" (action)="onNext()"></kpd-hotkey>

<div class="detail__grid">
  <div class="detail__alert"></div>

  <div class="detail__toolbar"></div>

  <div class="detail__main">
    <p-table
      dataKey="key"
      [value]="items"
      [selectionMode]="readOnlyMode ? null : 'multiple'"
      [scrollable]="true"
      class="table__fullheight"
      [resizableColumns]="true"
      [columns]="columnsConfig"
      [reorderableColumns]="true"
      [kpdTableRowSelection]="selectedKeys"
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
      kpdTableColumnReorder
      kpdTableSaveColumns="permissionDetailsPermissionset"
      [metaKeySelection]="true"
      [index]="index"
      kpdTableShiftClick
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
    >
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" translate>No records found</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <ng-container *ngIf="col.type !== 'KPD' && col.type !== 'type'">
              {{ rowData[col.field] }}
            </ng-container>
            <ng-container *ngIf="col.type === 'type'">
              <label class="tags">
                <span class="state-tag" [ngClass]="{ 'state-tag--disabled': !hasAssign(rowData[col.field]) }">{{
                  'Assign' | translate
                }}</span>
                <span class="state-tag" [ngClass]="{ 'state-tag--disabled': !hasUse(rowData[col.field]) }">{{
                  'Use' | translate
                }}</span>
              </label>
            </ng-container>
            <ng-container *ngIf="col.type === 'KPD' && rowData[col.field] === true">
              <label>
                <img
                  src="assets/logos/kpd-logo_36x16.svg"
                  alt="KPD"
                  [attr.title]="'This is a predefined set by KPD' | translate"
                  class="kpd-logo--blue-sm"
                />
              </label>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
